// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 76 ? "common" : chunkId) + "." + {"36":"2f0ca010e28f9ab4","76":"ad42dca7e61b016c","331":"2d3c6fd4a42b09bb","489":"d695d9f6c36dfbe4","995":"efd3fa70ff5bccbc"}[chunkId] + ".js";
};